import { useNavigate } from "react-router-dom";
import {
  PRESS_RELEASE_LIST_ROUTE,
  PRESS_RELEASE_ADD_ROUTE,
} from "constants/routeEnum";
import callApi from "Common/utils/apiCaller";
import * as Yup from "yup";
import { X } from "lucide-react";
import { useFormik } from "formik";
import { showNotification } from "Common/utils/Notification";
import { useState, useEffect } from "react";
import { TailSpin } from "react-loader-spinner";
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";
import { getImageUrl } from "Common/utils/ImageDomain";
import { ToastContainer } from "react-toastify";
import BreadCrumb from "../../Common/BreadCrumb";
import Drawer from "Common/Components/Drawer";
import ImageView from "Common/Components/ImageView/ImageView";
import HtmlCode from "Common/Components/HtmlCode/HtmlCode";
import ImageData from "Common/Components/customImage/Image";
import MultiDropdown from "Common/Components/searchComponent/searchApi";

const Addpressrelease = () => {
  const navigate = useNavigate();
  const [imageLink, setImageLink] = useState<any>();
  const [loader, setLoader] = useState<any>(false);
  const [content, setContent] = useState<any>("");
  const [imageData, setImageData] = useState<any>("");
  const [showImage, setShowImage] = useState<any>(false);
  const [addHtml, setAddHtml] = useState<any>();
  const toggleImage = () => setShowImage(!showImage);
  useEffect(() => {
    if (imageData && imageData?.media_url) {
      if (imageData?.content_type?.split("/")[0] === "image") {
        setImageLink(imageData);
      } else {
        showNotification("Please select Image", "error");
      }
    }
  }, [imageData]);
  const selectProperties = createSelector(
    (state: any) => state.Login,
    (profile) => ({
      permission: profile.permission,
      user: profile.user,
    })
  );

  const { permission, user } = useSelector(selectProperties);
  // validation
  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      heading: "",
      // url: "",
    },
    validationSchema: Yup.object({
      heading: Yup.string().required("Please enter heading"),
      // url: Yup.string().required("Pleas enter url"),
    }),

    onSubmit: async (values) => {
      const updateData = {
        ...values,
      };
      if (!!!imageLink?.media_url) {
        showNotification("Please add image", "error");
        return;
      }
      if (!!!content || content === "") {
        showNotification("Please add text", "error");
        return;
      }

      try {
        setLoader(true);
        const res = await callApi(`v1/pressrelease/new`, "post", {
          pressrelease: {
            thumbnail_url: imageLink?.media_url,
            thumbnail_media_id: imageLink?._id,
            heading: values?.heading,
            page_title: " ",
            // url: values?.url,
            meta_description: " ",
            meta_keyword: " ",
            canonical_url: " ",
            text: content,
            additional_html_id: addHtml?.value ? addHtml?.value : null,
          },
        });
        setLoader(false);
        if (res && res?.status === "Success") {
          showNotification("Pressrelease created successfully", "success");
          setLoader(true);
          setTimeout(() => {
            navigate(PRESS_RELEASE_LIST_ROUTE);
            setLoader(false);
          }, 1000);
        }
      } catch (e) {
        showNotification("something went wrong", "error");
      }
    },
  });

  const handleApiChange = (keyName, keyValue) => {
    setAddHtml(keyValue);
  };
  return (
    <>
      <BreadCrumb
        title={PRESS_RELEASE_ADD_ROUTE}
        pageTitle={PRESS_RELEASE_LIST_ROUTE}
        version="v1"
      />
      <ToastContainer />
      <div className="grid grid-cols-12 gap-x-5">
        <div className="col-span-12 card 2xl:col-span-12">
          <div className="p-6">
            <form
              className="create-form"
              id="create-form"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <input type="hidden" value="" name="id" id="id" />
              <input type="hidden" value="add" name="action" id="action" />
              <input type="hidden" id="id-field" />
              <div
                id="alert-error-msg"
                className="hidden px-4 py-3 text-sm text-red-500 border border-transparent rounded-md bg-red-50 dark:bg-red-500/20"
              ></div>
              <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
                <div className="xl:col-span-12">
                  <label
                    htmlFor="phoneNumberInput3"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Heading
                  </label>
                  <input
                    type="text"
                    id="phoneNumberInput3"
                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    placeholder="Enter Heading"
                    name="heading"
                    onChange={validation.handleChange}
                    value={validation.values.heading || ""}
                  />
                  {validation.touched.heading && validation.errors.heading ? (
                    <p className="text-red-400">{validation.errors.heading}</p>
                  ) : null}
                </div>
                {/* <div className="mb-2 xl:col-span-12">
                  <label
                    htmlFor="phoneNumberInput32"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Url
                  </label>
                  <input
                    type="text"
                    id="phoneNumberInput32"
                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    placeholder="Enter Url"
                    name="url"
                    onChange={validation.handleChange}
                    value={validation.values.url || ""}
                  />
                  {validation.touched.url && validation.errors.url ? (
                    <p className="text-red-400">{validation.errors.url}</p>
                  ) : null}
                </div> */}
              </div>
              <div className="m-4 ml-0 xl:col-span-12">
                {imageLink ? (
                  <div className="flex items-center">
                    <ImageData
                      imageLink={imageLink}
                      setImageLink={setImageLink}
                      setImageData={setImageData}
                    />
                    <div className="h-3 ml-3">
                      <div
                        onClick={() => {
                          setImageData(undefined);
                          toggleImage();
                        }}
                        // htmlFor="uploadimage49"
                        className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                      >
                        Change
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div
                      onClick={() => {
                        setImageData(undefined);
                        toggleImage();
                      }}
                      //htmlFor="uploadimage59"
                      className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                    >
                      {"Add Image"}
                    </div>
                  </>
                )}
              </div>
              <HtmlCode
                label={"Text"}
                content={content}
                setContent={setContent}
              />
              <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
                <div className="my-2 xl:col-span-6">
                  <label
                    htmlFor="phoneNumberInput3"
                    className="inline-block text-base font-medium"
                  >
                    Additional Html
                  </label>
                  <MultiDropdown
                    handleApiChange={handleApiChange}
                    pageType={"additional-html"}
                    name={"additional-html"}
                    value={addHtml}
                    type="additional_htmlList"
                    versionData={""}
                    id={"dfjj"}
                  />
                </div>
              </div>
              <div className="flex justify-end gap-2 mt-4">
                <button
                  type="reset"
                  id="close-modal"
                  data-modal-close="addEmployeeModal"
                  className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                  onClick={() => navigate(PRESS_RELEASE_LIST_ROUTE)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={loader}
                  id="addNew"
                  style={{
                    minWidth: "130px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                  className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                >
                  {loader ? (
                    <span>
                      <TailSpin
                        visible={true}
                        height="20"
                        width="20"
                        color="#fff"
                      />
                    </span>
                  ) : (
                    "Add Pressrelease"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Drawer
        show={showImage}
        onHide={toggleImage}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Select Image"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <ImageView
            showImage={showImage}
            setEventData={setImageData}
            togleImage={toggleImage}
          />
        </Drawer.Body>
      </Drawer>
    </>
  );
};

export default Addpressrelease;
